/**
 * A calm base map, so the route stands out: business and transit icons are hidden and the colors
 * are muted. Works only on maps without a cloud map ID, which this map does not use.
 */
export const routeMapStyles: google.maps.MapTypeStyle[] = [
  {elementType: 'geometry', stylers: [{saturation: -70}, {lightness: 10}]},
  {featureType: 'poi', stylers: [{visibility: 'off'}]},
  {featureType: 'poi.park', elementType: 'geometry', stylers: [{visibility: 'on'}]},
  {featureType: 'transit', stylers: [{visibility: 'off'}]},
  {featureType: 'road', elementType: 'labels.icon', stylers: [{visibility: 'off'}]},
  {featureType: 'road', elementType: 'geometry', stylers: [{saturation: -100}, {lightness: 20}]},
  {elementType: 'labels.text.fill', stylers: [{saturation: -100}, {lightness: 25}]},
];
